export function TablePlaceholder({ rows = 12, count = 6 }) {
  return [...Array(rows)].map((_, rowIndex) => (
    <tr key={rowIndex}>
      {[...Array(count)].map((_, colIndex) => (
        <td key={colIndex}>
          <p className="placeholder-glow">
            <span className="placeholder col-12" />
          </p>
        </td>
      ))}
    </tr>
  ));
}
